import { render, staticRenderFns } from "./CurrencyVisualizer.vue?vue&type=template&id=2849b92e&scoped=true&"
import script from "./CurrencyVisualizer.vue?vue&type=script&lang=js&"
export * from "./CurrencyVisualizer.vue?vue&type=script&lang=js&"
import style0 from "./CurrencyVisualizer.vue?vue&type=style&index=0&id=2849b92e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2849b92e",
  null
  
)

export default component.exports